import { getEnv, getRegion, getAccOrigin } from '@adsk/acs-sc-web-platform-api';
export function getExoSkeletonRemotesUrl() {
  const env = getEnv();
  const region = getRegion();
  const remotesRegion = ['EMEA', 'APAC', 'AUS'].includes(region) ? region : 'US';
  return "".concat(getAccOrigin({
    region: remotesRegion
  }), "/assets/exo/remotes/remotes.").concat(env.toLowerCase(), ".").concat(remotesRegion.toLowerCase(), ".json");
}
//# sourceMappingURL=getExoSkeletonRemotesUrl.js.map